export function Loading() {
	return (
		<div className="flex justify-center items-center absolute top-0 left-0 right-0 bottom-0">
			<span className="loader"></span>
		</div>
	)
}
